import { rollD6 } from './rng';
import type { RngState } from './types';

export interface DiceOutcome {
  attacker: number[];
  defender: number[];
  attackerLosses: number;
  defenderLosses: number;
}

/** Roll and compare. Highest against highest, ties go to the defender. */
export function resolveDice(
  rng: RngState,
  attackDice: number,
  defendDice: number,
): [DiceOutcome, RngState] {
  let r = rng;
  const attacker: number[] = [];
  const defender: number[] = [];
  for (let i = 0; i < attackDice; i++) {
    let v: number;
    [v, r] = rollD6(r);
    attacker.push(v);
  }
  for (let i = 0; i < defendDice; i++) {
    let v: number;
    [v, r] = rollD6(r);
    defender.push(v);
  }
  const a = [...attacker].sort((x, y) => y - x);
  const d = [...defender].sort((x, y) => y - x);
  let attackerLosses = 0;
  let defenderLosses = 0;
  for (let i = 0; i < Math.min(a.length, d.length); i++) {
    if (a[i]! > d[i]!) defenderLosses++;
    else attackerLosses++;
  }
  return [{ attacker, defender, attackerLosses, defenderLosses }, r];
}
